import styled from "styled-components";

export const TrainNumbers = styled.div`
  display: flex;
  gap: 12px;
`;

export const TrainDate = styled.span`
  display: inline-block;
  color: ${({ theme }) => theme.colorTextSecondary};
`;
